import React, { useState, useEffect } from 'react';
import { Sparkles, Terminal } from 'lucide-react';
import './WritingWorkshopAnimation.css';

const WritingWorkshopAnimation = () => {
  const essayLines = [
    "Critique of the Classical Narrative Paradigm...",
    "The thematic undercurrent of alienation is underscored by...",
    "Through careful syntactic inversion, Whitehead demonstrates...",
    "Synthesizing contemporary exposition with traditional motifs...",
    "Thus, structural paradigm shifts reveal deeper subtexts..."
  ];

  const [activeLine, setActiveLine] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(70);

  // Advanced Typewriter Mechanism for the "Essay Assignment" terminal
  useEffect(() => {
    let timer;
    const currentFullText = essayLines[activeLine];

    const handleType = () => {
      if (!isDeleting) {
        setTypedText(currentFullText.substring(0, typedText.length + 1));
        if (typedText === currentFullText) {
          timer = setTimeout(() => setIsDeleting(true), 2500); // Wait before clearing
          return;
        }
      } else {
        setTypedText(currentFullText.substring(0, typedText.length - 1));
        if (typedText === "") {
          setIsDeleting(false);
          setActiveLine((prev) => (prev + 1) % essayLines.length);
          return;
        }
      }
      setTypingSpeed(isDeleting ? 30 : 60);
    };

    timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [typedText, isDeleting, activeLine]);

  return (
    <div className="tpa-lit-container">
      
      {/* 1. Backdrop Text Texture Matrix Layer */}
      <div className="tpa-lit-matrix-overlay">
        <span>HERMENEUTICS</span><span>RHETORIC</span><span>SYNTAX</span>
        <span>PROSE</span><span>COMPOSITION</span><span>ANALYSIS</span>
      </div>

      {/* 2. Top Element: The Live Compiling Essay Console */}
      <div className="tpa-lit-essay-terminal">
        <div className="tpa-lit-terminal-header">
          <div className="tpa-lit-window-dots">
            <span className="tpa-dot-r"></span>
            <span className="tpa-dot-y"></span>
            <span className="tpa-dot-g"></span>
          </div>
          <span className="tpa-lit-terminal-title"><Terminal size={12} /> essay_draft.docx</span>
        </div>
        <div className="tpa-lit-terminal-body">
          <p className="tpa-lit-typing-line">
            {typedText}
            <span className="tpa-lit-cursor">|</span>
          </p>
        </div>
      </div>

      {/* 3. Bottom Element: The Mechanical Book Engine */}
      <div className="tpa-lit-book-wrapper">
        <div className="tpa-lit-book-spine"></div>
        
        {/* Left Fixed Page */}
        <div className="tpa-lit-page tpa-lit-page-left">
          <div className="tpa-lit-text-skeleton">
            <div className="tpa-line long"></div>
            <div className="tpa-line medium tpa-highlighted-yellow"></div>
            <div className="tpa-line long"></div>
            <div className="tpa-line short"></div>
          </div>
        </div>

        {/* Flipping Center Pages */}
        <div className="tpa-lit-page tpa-lit-page-flipping flip-1">
          <div className="tpa-lit-text-skeleton">
            <div className="tpa-line long"></div>
            <div className="tpa-line short tpa-highlighted-gold"></div>
            <div className="tpa-line long"></div>
          </div>
        </div>

        <div className="tpa-lit-page tpa-lit-page-flipping flip-2">
          <div className="tpa-lit-text-skeleton">
            <div className="tpa-line medium"></div>
            <div className="tpa-line long"></div>
            <div className="tpa-line short"></div>
          </div>
        </div>

        {/* Right Fixed Page */}
        <div className="tpa-lit-page tpa-lit-page-right">
          <div className="tpa-lit-text-skeleton">
            <div className="tpa-line long"></div>
            <div className="tpa-line medium"></div>
            <div className="tpa-line long tpa-highlighted-gold"></div>
            <div className="tpa-line short"></div>
          </div>
        </div>
      </div>

      {/* Floating Sparkles for literary inspiration vibe */}
      <div className="tpa-lit-sparkle-drift">
        <Sparkles size={16} className="sparkle-1" />
        <Sparkles size={14} className="sparkle-2" />
      </div>
    </div>
  );
};

export default WritingWorkshopAnimation;